import { Divider, Space } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader } from "../../Common/Components";
import { useFetchStatisticForPersonInSeason, useFetchStatisticForTeamInSeason } from "../../entities/api";
import TeamPlayerStatsAverage from "./TeamPlayerStatsAverage";
import TeamPlayerStatsTotal from "./TeamPlayerStatsTotal";
import "./TeamStats.scss";
import TeamSummaryStats from "./TeamSummaryStats";

const SeasonTeamStats = () => {
  const [tableData, setTableData] = useState();
  const now = useMemo(() => new Date(), []);
  const { seasonId } = useParams();
  const { data, isLoading: isPersonLoading } = useFetchStatisticForPersonInSeason({
    include: "entities,persons,organizations,seasons",
    limit: 1000,
  });
  const { data: teams, isLoading: isTeamLoading } = useFetchStatisticForTeamInSeason({
    limit: 1000,
    include: "organizations,entities,seasons",
  });

  useEffect(() => {
    if (data && teams) {
      const personData = data.data ? data.data : [];
      personData.forEach((person, index) => {
        if (person.person.id) {
          // Load names from resources
          personData[index].personObj = data.includes?.resources?.persons?.[person.person.id];
          personData[index].person = data.includes?.resources?.persons?.[person.person.id]?.nameFullLocal || "";
          personData[index].team = data.includes?.resources?.entities?.[person.entity.id]?.nameFullLocal || "";
        }
      });
      let teamData = teams?.data || [];
      teamData.forEach((team, index) => {
        teamData[index].team = teams.includes?.resources?.entities?.[team.entity.id]?.nameFullLocal;
      });
      teamData = teamData.sort((a, b) => a.team?.localeCompare(b.team));
      const tableList = teamData.map((team, index) => {
        return (
          <div key={index} className="team-stats" style={{ width: "100%" }}>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <TeamPlayerStatsTotal
                title={team.team}
                data={personData.filter((person) => person.entity.id === team.entity.id)}
                includes={data?.includes?.resources}
                team={team}
              />
              <TeamPlayerStatsAverage
                title={team.team}
                data={personData.filter((person) => person.entity.id === team.entity.id)}
                includes={data.includes?.resources}
                team={team}
              />
              <TeamSummaryStats team={team} title={team.team} />
            </Space>
            <Divider />
          </div>
        );
      });
      setTableData(tableList);
    }
  }, [data, teams, seasonId, now]);

  return (
    <React.Fragment>
      {tableData}
      <div className="print-date print-only">Printed: {now.toString()}</div>
      {(isTeamLoading || isPersonLoading) && <Loader />}
    </React.Fragment>
  );
};

export default SeasonTeamStats;
